export const ENROL_URL =
  "https://www.xap.rocks/waiting-list?organisationId=f8190045-7dd2-46ac-ae14-d0af606ba457";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LOGO_URL =
  "https://static.prod-images.emergentagent.com/jobs/885a4fd0-7fa6-4e64-b0e8-3d460900c1ea/images/7d8fb0432c019a314fe3ae4547302d47988e66026827436a9d90343f79fdf09f.jpeg";

export const NAV_LINKS = [
  { to: "/", label: "Home", testId: "nav-link-home" },
  { to: "/about", label: "About & Philosophy", testId: "nav-link-about" },
  { to: "/programs", label: "Programs", testId: "nav-link-programs" },
  { to: "/team", label: "Team", testId: "nav-link-team" },
  { to: "/fees", label: "Fees & CCS", testId: "nav-link-fees" },
  { to: "/policies", label: "Policies", testId: "nav-link-policies" },
  { to: "/nqs", label: "NQS Quality", testId: "nav-link-nqs" },
  { to: "/announcements", label: "Announcements", testId: "nav-link-announcements" },
  { to: "/contact", label: "Contact", testId: "nav-link-contact" },
];

export const IMAGES = {
  hero: "https://customer-assets-7cd3h4nn.emergentagent.net/job_telopea-premium-care/artifacts/90gw3qh9_image.png",
  playing: "/images/home-beads.webp",
  playground: "/images/asc-courts.webp",
  crafts: "https://images.unsplash.com/photo-1617117206620-b01f2919ff86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxraWRzJTIwZG9pbmclMjBjcmFmdHN8ZW58MHx8fHwxNzg2NDIwMzEzfDA&ixlib=rb-4.1.0&q=85",
  craftsHands: "https://images.unsplash.com/photo-1609446154807-d56805f0e007?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxraWRzJTIwZG9pbmclMjBjcmFmdHN8ZW58MHx8fHwxNzg2NDIwMzEzfDA&ixlib=rb-4.1.0&q=85",
  sandbox: "/images/about-parachute.webp",
  excursion: "https://customer-assets-7cd3h4nn.emergentagent.net/job_telopea-premium-care/artifacts/wxliuhau_IMG_4849%20%281%29.webp",
  tap: "/images/tap-activity-lego.webp",
  running: "/images/bsc-lego-v2.webp",
  friends: "/images/team-excursion.webp",
  waratah: "https://images.unsplash.com/photo-1665471645001-4b7bb0732374?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHx3YXJhdGFoJTIwZmxvd2VyJTIwcmVkfGVufDB8fHx8MTc4NjQyMDM4NHww&ixlib=rb-4.1.0&q=85",
};

export const FEES = {
  effective: "August 2026",
  membership: { label: "Annual membership & account keeping fee", amount: 30 },
  bsc: { label: "Before School Care", permanent: 26.45, casual: 28.55 },
  asc: { label: "After School Care", permanent: 37.85, casual: 40.2 },
  svc: { label: "School Vacation Care (per session)", amount: 103.35 },
  excursionLevy: 10,
};

export const NQS_AREAS = [
  { id: 1, name: "Educational Program and Practice", rating: "Meeting NQS", desc: "How the program supports each child's learning, development and wellbeing through play-based experiences." },
  { id: 2, name: "Children's Health and Safety", rating: "Meeting NQS", desc: "Safeguarding children's health, safety and wellbeing, including supervision, nutrition and safe sleep and hygiene practices." },
  { id: 3, name: "Physical Environment", rating: "Meeting NQS", desc: "Safe, well-maintained and stimulating indoor and outdoor spaces that invite exploration and play." },
  { id: 4, name: "Staffing Arrangements", rating: "Exceeding NQS", desc: "Qualified, consistent educators with ratios and continuity that support secure relationships with children." },
  { id: 5, name: "Relationships with Children", rating: "Exceeding NQS", desc: "Respectful, warm and responsive relationships that help every child feel safe, seen and confident." },
  { id: 6, name: "Partnerships with Families and Communities", rating: "Exceeding NQS", desc: "Genuine collaboration with families and the wider school and Canberra community in each child's care." },
  { id: 7, name: "Governance and Leadership", rating: "Exceeding NQS", desc: "Strong management systems, self-assessment and continuous improvement guiding the service." },
];

export const NQS_ASSESSMENT_DATE = "27 May 2025";
